module.exports = __webpack_public_path__ + "images/c512dbce4017c7514dec9fd0ff03de14.jpg";